export var getBackgroundColor = function (_a) {
    var opacity = _a.opacity, whiteBackground = _a.whiteBackground, transparent = _a.transparent, inherit = _a.inherit;
    if (transparent) {
        return 'transparent';
    }
    if (inherit) {
        return 'inherit';
    }
    var baseColor = whiteBackground ? '255, 255, 255' : '0, 0, 0';
    return "rgba(" + baseColor + ", " + opacity + ")";
};
